import { Slot } from "@radix-ui/react-slot";
import { cn } from "@scott/ui/utils/cn";
import type { ImgHTMLAttributes } from "react";

interface pinterestProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

const Pinterest = ({ className, asChild = false }: pinterestProps) => {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn("fill-[--brand-followus-logo]", className)}
      fill="none"
      height="32"
      viewBox="0 0 28 28"
      width="28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24 0C26.1875 0 28 1.8125 28 4V24C28 26.25 26.1875 28 24 28H9.625C10.25 27 11 25.5 11.3125 24.3125C11.5 23.625 12.3125 20.6875 12.3125 20.6875C12.8125 21.625 14.25 22.4375 15.8125 22.4375C20.4375 22.4375 23.75 18.1875 23.75 12.875C23.75 7.8125 19.625 4 14.3125 4C7.6875 4 4.1875 8.5 4.1875 13.3125C4.1875 15.5625 5.375 18.375 7.3125 19.25C7.5625 19.375 7.75 19.3125 7.8125 19.0625C7.8125 19 7.875 18.75 7.9375 18.5C8 18.125 8.125 17.625 8.25 17.3125C8.25 17.1875 8.25 17 8.125 16.875C7.5 16.125 7 14.6875 7 13.375C7 10 9.5625 6.6875 13.875 6.6875C17.6875 6.6875 20.3125 9.3125 20.3125 12.9375C20.3125 17.125 18.25 20 15.5 20C14 20 12.875 18.75 13.1875 17.1875C13.375 16.5625 13.5625 15.875 13.8125 15.1875C14.125 14.0625 14.5 12.9375 14.5 12.125C14.5 8.8125 9.75 9.25 9.75 13.6875C9.75 15 10.25 15.9375 10.25 15.9375C9.875 17.375 9.625 18.5625 9.375 19.5625C8.1875 24.375 8.0625 25 8.375 28H8.5H4C1.75 28 0 26.25 0 24V4C0 1.8125 1.75 0 4 0H24Z" />
    </Comp>
  );
};

Pinterest.displayName = "Paypal";

export { Pinterest };
